import { render, staticRenderFns } from "./PayoutPage.vue?vue&type=template&id=8818246a&"
import script from "./PayoutPage.vue?vue&type=script&lang=js&"
export * from "./PayoutPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports